import { computed as m, unref as W, ref as K, watch as _, onMounted as oe, defineComponent as se, toRefs as ne, openBlock as ie, createElementBlock as ae } from "vue";
import { merge as le } from "lodash-es";
import { useOnline as ue } from "@vueuse/core";
import { useGlobalDark as ce } from "./hooks/useGlobalDark.js";
import { useMobileView as Y } from "./hooks/useMobileView.js";
import { shortUUID as de } from "./utils/uuid.js";
import { getTimezone as j, formatUTCDate as me, formatDate as pe, formatUTCTime as he, formatTime as fe } from "./utils/datetime.js";
import { ls as v } from "x-utils";
import { useStyledLog as ye } from "./hooks/useStyledLog.js";
function Se(o) {
  let t = o;
  return /m$/.test(o) && (t = o.replace("m", "")), /h$/.test(o) && (t = (Number(o.replace("h", "")) * 60).toString()), t;
}
function H(o) {
  if (/\d+$/.test(o)) {
    const t = parseInt(o);
    return t >= 60 ? `${t / 60}h` : `${o}m`;
  }
  return o;
}
const M = "crypto.tradingview.charts", $ = "crypto.tradingview.studyTemplates", z = "crypto.tradingview.drawingTemplates";
function E() {
  return v.getItem(M, []);
}
function ve(o) {
  try {
    const t = E();
    let e = !1;
    for (const r of t)
      r.symbol !== o && (r.content = r.content.replace(new RegExp(r.symbol, "g"), o), r.symbol = o, e = !0);
    e && v.setItem(M, t);
  } catch (t) {
    console.log(t);
  }
}
function R() {
  return v.getItem($, []);
}
function U() {
  return v.getItem(z, []);
}
const ge = {
  getAllCharts: function() {
    const o = E();
    return Promise.resolve(o);
  },
  saveChart: function(o) {
    o.id ? this.removeChart(o.id) : o.id = Math.random().toString(), o.timestamp = (/* @__PURE__ */ new Date()).valueOf();
    const t = E();
    return t.push(o), v.setItem(M, t), Promise.resolve(o.id);
  },
  removeChart: function(o) {
    const t = E();
    for (let e = 0; e < t.length; ++e)
      t[e].id === o && t.splice(e, 1);
    return v.setItem(M, t), Promise.resolve();
  },
  getChartContent: function(o) {
    const t = E();
    for (let e = 0; e < t.length; ++e)
      if (t[e].id === o)
        return Promise.resolve(t[e].content);
    return console.error("error"), Promise.reject();
  },
  getAllStudyTemplates: function() {
    return Promise.resolve(R());
  },
  saveStudyTemplate: function(o) {
    const t = R();
    for (let e = 0; e < t.length; ++e)
      if (t[e].name === o.name) {
        t.splice(e, 1);
        break;
      }
    return t.push(o), v.setItem($, t), Promise.resolve();
  },
  removeStudyTemplate: function(o) {
    const t = R();
    for (let e = 0; e < t.length; ++e)
      if (t[e].name === o.name) {
        t.splice(e, 1);
        break;
      }
    return v.setItem($, t), Promise.resolve();
  },
  getStudyTemplateContent: function(o) {
    const t = R();
    for (let e = 0; e < t.length; ++e)
      if (t[e].name === o.name)
        return Promise.resolve(t[e]);
    return console.error("st: error"), Promise.reject();
  },
  getDrawingTemplates: function() {
    const o = U();
    return Promise.resolve(o.map(function(t) {
      return t.name;
    }));
  },
  saveDrawingTemplate: function(o, t, e) {
    const r = U();
    for (let s = 0; s < r.length; ++s)
      if (r[s].name === t) {
        r.splice(s, 1);
        break;
      }
    return r.push({ name: t, content: e }), v.setItem(z, r), Promise.resolve();
  },
  removeDrawingTemplate: function(o, t) {
    const e = U();
    for (let r = 0; r < e.length; ++r)
      if (e[r].name === t) {
        e.splice(r, 1);
        break;
      }
    return v.setItem(z, e), Promise.reject();
  },
  loadDrawingTemplate: function(o, t) {
    const e = U();
    for (let r = 0; r < e.length; ++r)
      if (e[r].name === t)
        return Promise.resolve(e[r].content);
    return console.error("drawing: error"), Promise.reject();
  }
}, Ce = ge, q = "crypto.tradingview.studies", N = "Volume";
function be(o, t) {
  return new Pe(o, t);
}
class Pe {
  chart;
  studyKeys;
  studyItems;
  defaultStudies;
  constructor(t, e) {
    const r = t.chart();
    this.chart = r, this.studyKeys = [], this.studyItems = [], this.defaultStudies = e, this.createStudies(), t?.subscribe("study", () => {
      setTimeout(() => {
        this.addStudy();
      });
    }), t?.subscribe("study_event", (s, n) => {
      n === "remove" && setTimeout(() => {
        this.removeStudy();
      });
    });
  }
  createStudies() {
    if (E().length)
      return;
    const e = v.getItem(q, []), r = this.chart;
    e.length ? e.forEach((s) => {
      if (s.name !== N) {
        const n = {
          name: s.name,
          inputs: s.inputs || null,
          options: s.options
        };
        this.createStudy(r, n);
      }
    }) : this.defaultStudies.forEach((s) => {
      const n = {
        name: s.name,
        inputs: s.inputs,
        options: s.options
      };
      this.createStudy(r, n);
    });
  }
  createStudy(t, e) {
    const r = JSON.stringify({ name: e.name, inputs: e.inputs });
    this.studyKeys.indexOf(r) < 0 && t.createStudy(e.name, !1, !1, e.inputs, e.options).then((s) => {
      s && (this.studyItems.push({ ...e, id: s, inputs: e.inputs }), this.studyKeys.push(r));
    });
  }
  addStudy() {
    const e = this.chart.getAllStudies(), s = this.studyItems.map((n) => n.id);
    e.forEach((n) => {
      n.name !== N && s.indexOf(n.id) < 0 && this.studyItems.push(n);
    }), this.saveStudyItems();
  }
  removeStudy() {
    const e = this.chart.getAllStudies(), r = this.studyItems, s = e.map((n) => n.id);
    r.forEach((n, p) => {
      n.name !== N && s.indexOf(n.id) < 0 && this.studyItems.splice(p, 1);
    }), this.saveStudyItems();
  }
  saveStudyItems() {
    v.setItem(q, this.studyItems);
  }
}
const _e = ["1", "5", "15", "30", "60", "120", "240", "360", "720", "1D", "1W", "2W", "1M"], V = {
  upColor: "#00A68C",
  downColor: "#E0485C",
  loadLastChart: !1,
  defaultStudies: void 0
}, J = {
  bodyTextColor: "#fff",
  font: "normal 12px Inter, sans-serif"
};
function we(o, t) {
  const { bodyTextColor: e, font: r } = J;
  t.forEach((s) => {
    const { text: n, price: p, quantity: u, lineLength: a, color: c, backgroundColor: g } = s;
    o.createOrderLine().setBodyFont(r).setText(n).setLineLength(a).setLineColor(c).setLineStyle(1).setBodyTextColor(e).setBodyBorderColor(g).setBodyBackgroundColor(g).setQuantityBorderColor(c).setQuantityBackgroundColor(c).setQuantity(u).setQuantityFont(r).setPrice(p);
  });
}
function Te(o, t) {
  const { bodyTextColor: e, font: r } = J, { text: s, price: n, quantity: p, lineLength: u, backgroundColor: a, color: c, closePositionHandler: g } = t, w = o.createPositionLine().onClose(() => {
    g().then(() => {
      w.remove();
    });
  }).setBodyFont(r).setText(s).setLineLength(u).setLineStyle(1).setBodyTextColor(e).setBodyBorderColor(a).setBodyBackgroundColor(a).setQuantityBorderColor(c).setQuantityBackgroundColor(c).setQuantity(p).setQuantityFont(r).setPrice(n);
  return w;
}
function ke(o, t) {
  const { text: e, price: r, quantity: s, backgroundColor: n } = t;
  o.setText(e).setPrice(r).setQuantity(s).setBodyBorderColor(n).setBodyBackgroundColor(n);
}
class Be {
  subscriptions;
  constructor() {
    this.subscriptions = {};
  }
  addSubscription(t, e) {
    this.subscriptions[t] = e;
  }
  removeSubscription(t) {
    delete this.subscriptions[t];
  }
  getSubscription(t) {
    return this.subscriptions[t];
  }
  getOnTick(t) {
    return this.subscriptions[t]?.onTick;
  }
}
let G = null;
function Ee(o) {
  const { count: t, supportedResolutions: e, getBars: r, logEnabled: s, marks: n, exchangeName: p } = o, u = ye({ enabled: s }), a = new Be(), c = {
    supported_resolutions: e,
    supports_group_request: !1,
    supports_marks: !0,
    supports_search: !1,
    supports_timescale_marks: !1
  };
  return {
    createDatafeed: () => ({
      onReady(l) {
        setTimeout(() => {
          l(c);
        });
      },
      searchSymbols: async (l, y, S, d) => {
      },
      getMarks(l, y, S, d, C) {
        n?.value.length && d(n.value);
      },
      resolveSymbol: async (l, y) => {
        setTimeout(() => {
          u.info("[resolveSymbol]: Method call", l);
          const { instrumentName: S, displayName: d, pricescale: C, volumePrecision: T } = o, h = {
            name: l,
            type: "crypto",
            exchange: p ?? "crypto.com",
            listed_exchange: p ?? "crypto.com",
            supported_resolutions: c.supported_resolutions,
            minmov: 1,
            format: "price",
            visible_plots_set: "ohlcv",
            volume_precision: T.value,
            full_name: d.value,
            description: d.value,
            pricescale: C.value,
            ticker: S.value,
            session: "24x7",
            has_intraday: !0,
            timezone: j(),
            has_weekly_and_monthly: !0
          };
          y(h);
        });
      },
      getBars: async (l, y, S, d, C) => {
        u.info("[getBars]: Method call", { symbolInfo: l, resolution: y, periodParams: S });
        const { firstDataRequest: T } = S;
        T && (G = null);
        try {
          const h = await r({
            instrumentName: l.name,
            interval: H(y),
            endTime: G
          });
          if (h.length === 0) {
            d([], {
              noData: !0
            });
            return;
          }
          G = h[0].time, u.info(`[getBars]: returned ${h.length} bar(s)`), d(h, { noData: h.length < t });
        } catch (h) {
          console.log("[getBars]: Get error", h, C), C(h);
        }
      },
      subscribeBars: (l, y, S, d, C) => {
        u.info("[subscribeBars]: Method call with subscriberUID:", d, l), a.addSubscription(d, {
          interval: y,
          onTick: S,
          listenerGuid: d,
          onResetCacheNeededCallback: C
        });
      },
      unsubscribeBars: (l) => {
        u.info("[unsubscribeBars]: Method call with subscriberUID:", l), a.removeSubscription(l);
      }
    }),
    subscriptionManager: a
  };
}
const Le = ["side_toolbar_in_fullscreen_mode"], Ie = [
  "header_symbol_search",
  "timeframes_toolbar",
  "volume_force_overlay",
  // 'header_resolutions',
  "header_compare",
  // 'header_undo_redo',
  // 'timezone_menu',
  // 'scales_context_menu',
  "legend_context_menu",
  "symbol_search_hot_key"
  // 'use_localstorage_for_settings',
], Fe = [
  // 'header_indicators',
  // 'symbol_info',
  "left_toolbar",
  // 'header_chart_type',
  "header_fullscreen_button"
];
function De(o, t) {
  const { isMobile: e } = Y();
  return m(() => ({
    disabled_features: Ie.concat(W(o)).concat(e.value ? Fe : []),
    enabled_features: Le.concat(W(t))
  }));
}
function Oe(o, t) {
  return m(() => {
    const e = o.value, r = t.value;
    return {
      /**
      * different chart types
      * @see https://www.tradingview.com/charting-library-docs/latest/customization/overrides/
      */
      // Candles styles
      "mainSeriesProperties.candleStyle.upColor": e,
      "mainSeriesProperties.candleStyle.downColor": r,
      "mainSeriesProperties.candleStyle.borderUpColor": e,
      "mainSeriesProperties.candleStyle.borderDownColor": r,
      "mainSeriesProperties.candleStyle.wickUpColor": e,
      "mainSeriesProperties.candleStyle.wickDownColor": r,
      // Hollow Candles styles
      "mainSeriesProperties.hollowCandleStyle.upColor": e,
      "mainSeriesProperties.hollowCandleStyle.downColor": r,
      "mainSeriesProperties.hollowCandleStyle.borderUpColor": e,
      "mainSeriesProperties.hollowCandleStyle.borderDownColor": r,
      "mainSeriesProperties.hollowCandleStyle.wickUpColor": e,
      "mainSeriesProperties.hollowCandleStyle.wickDownColor": r,
      // Heikin Ashi styles
      "mainSeriesProperties.haStyle.upColor": e,
      "mainSeriesProperties.haStyle.downColor": r,
      "mainSeriesProperties.haStyle.borderUpColor": e,
      "mainSeriesProperties.haStyle.borderDownColor": r,
      "mainSeriesProperties.haStyle.wickUpColor": e,
      "mainSeriesProperties.haStyle.wickDownColor": r,
      // Bar styles
      "mainSeriesProperties.barStyle.upColor": e,
      "mainSeriesProperties.barStyle.downColor": r,
      // Column styles
      "mainSeriesProperties.columnStyle.upColor": e,
      "mainSeriesProperties.columnStyle.downColor": r,
      // Line styles
      "mainSeriesProperties.lineStyle.color": "#1199FA",
      // Area styles
      "mainSeriesProperties.areaStyle.color1": "rgba(46, 165, 251, 0.28)",
      "mainSeriesProperties.areaStyle.color2": "#1199FA",
      "mainSeriesProperties.areaStyle.linecolor": "#1199FA",
      // Hi-Lo styles
      "mainSeriesProperties.hiloStyle.color": "#1199FA",
      "mainSeriesProperties.hiloStyle.showBorders": !0,
      "mainSeriesProperties.hiloStyle.borderColor": "#1199FA",
      "mainSeriesProperties.hiloStyle.showLabels": !0,
      "mainSeriesProperties.hiloStyle.labelColor": "#1199FA",
      // Renko styles
      "mainSeriesProperties.renkoStyle.upColor": e,
      "mainSeriesProperties.renkoStyle.downColor": r,
      "mainSeriesProperties.renkoStyle.borderUpColor": e,
      "mainSeriesProperties.renkoStyle.borderDownColor": r,
      "mainSeriesProperties.renkoStyle.wickUpColor": e,
      "mainSeriesProperties.renkoStyle.wickDownColor": r,
      // Kagi styles
      "mainSeriesProperties.kagiStyle.upColor": e,
      "mainSeriesProperties.kagiStyle.downColor": r,
      // Point&Figure styles
      "mainSeriesProperties.pnfStyle.upColor": e,
      "mainSeriesProperties.pnfStyle.downColor": r,
      // Range styles
      "mainSeriesProperties.rangeStyle.upColor": e,
      "mainSeriesProperties.rangeStyle.downColor": r
    };
  });
}
function Ae(o) {
  const { isDark: t, isMobile: e, upColor: r, downColor: s } = o, n = m(() => ({
    volumePaneSize: e.value ? "small" : "medium",
    "paneProperties.backgroundType": "solid",
    "paneProperties.crossHairProperties.width": 1,
    "paneProperties.legendProperties.showLegend": !0,
    timezone: j()
  })), p = m(() => t.value ? {
    "paneProperties.background": "#0B1426",
    "paneProperties.backgroundGradientStartColor": "#0B1426",
    "paneProperties.backgroundGradientEndColor": "#0B1426",
    "paneProperties.vertGridProperties.color": "#121928",
    "paneProperties.horzGridProperties.color": "#121928",
    "paneProperties.separatorColor": "#2A2E39"
  } : {
    "paneProperties.background": "#FFF",
    "paneProperties.backgroundGradientStartColor": "#FFF",
    "paneProperties.backgroundGradientEndColor": "#FFF",
    "paneProperties.vertGridProperties.color": "#F7F9FA",
    "paneProperties.horzGridProperties.color": "#F7F9FA",
    "paneProperties.separatorColor": "#E0E3EB"
  }), u = Oe(r, s), a = m(() => ({
    "volume.volume.color.0": s.value,
    "volume.volume.color.1": r.value
  })), c = m(() => ({
    "volume.color.0": s.value,
    "volume.color.1": r.value
  })), g = m(() => ({
    ...n.value,
    ...p.value,
    ...u.value
  }));
  return {
    themeOverrides: p,
    colorOverrides: u,
    studyOverrides: a,
    overrides: g,
    studyOverridesForChart: c
  };
}
function xe(o) {
  const { interval: t, instrumentName: e, datafeedOptions: r, libraryPath: s, customCSSUrl: n, debug: p, theme: u, widgetOptions: a, emit: c, disabledFeatures: g = [], enabledFeatures: w = [] } = o, l = `tradingview_${de()}`, y = ce(), { isMobile: S } = Y(), d = ue(), { createDatafeed: C, subscriptionManager: T } = Ee(r), h = De(g, w), L = K(!1), b = K(null), I = m(() => u ? u === "Dark" : y.value), { loadLastChart: F, defaultStudies: A } = a.value, D = m(() => a.value.upColor), x = m(() => a.value.downColor), P = m(() => a.value.orderLines), k = m(() => a.value.positionLine), { overrides: B, themeOverrides: X, colorOverrides: Z, studyOverrides: ee, studyOverridesForChart: te } = Ae({ isDark: I, isMobile: S, upColor: D, downColor: x });
  let i = null;
  const Q = () => {
    if (i) return;
    ve(e.value);
    const f = window.TradingView.widget;
    i = new f({
      ...h.value,
      container: l,
      datafeed: C(),
      interval: t.value,
      symbol: e.value,
      locale: "en",
      autosize: !0,
      library_path: s,
      charts_storage_url: "https://saveload.tradingview.com",
      charts_storage_api_version: "1.1",
      theme: u ?? (I.value ? "Dark" : "Light"),
      custom_css_url: n,
      load_last_chart: F,
      save_load_adapter: Ce,
      loading_screen: { foregroundColor: "#2EA5FB" },
      custom_formatters: {
        dateFormatter: {
          format: me,
          formatLocal: pe
        },
        timeFormatter: {
          format: he,
          formatLocal: fe
        }
      },
      studies_overrides: ee.value,
      debug: p
    }), F && i.headerReady().then(() => {
      i?.chart().setResolution(t.value, () => {
        i?.chart().executeActionById("chartReset");
      });
    }), i.onChartReady(() => {
      if (c("chart-ready", !0), L.value = !0, i) {
        i.applyOverrides(B.value);
        const O = i.activeChart();
        O.onIntervalChanged().subscribe(
          null,
          (re) => {
            c("interval-change", H(re));
          }
        ), A && be(i, A), P.value && we(O, P.value);
      }
    });
  };
  return _(d, (f) => {
    f ? Q() : i && (i.remove(), i = null);
  }), _(I, (f) => {
    i?.changeTheme(f ? "Dark" : "Light"), setTimeout(() => {
      i?.applyOverrides(X.value);
    });
  }), _(a, () => {
    if (i) {
      i.applyOverrides(Z.value);
      const f = i?.activeChart();
      f.getAllStudies().forEach((O) => {
        O.name === "Volume" && f.getStudyById(O.id).applyOverrides(te.value);
      });
    }
  }), _(k, (f) => {
    !i || !L.value || (f ? b.value ? ke(b.value, f) : b.value = Te(i.activeChart(), f) : b.value && (b.value.remove(), b.value = null));
  }), _(e, () => {
    i?.setSymbol(e.value, t.value, () => {
      i?.chart().executeActionById("chartReset");
    });
  }), _(t, (f) => {
    i?.chart().setResolution(f, () => {
      i?.chart().executeActionById("chartReset");
    });
  }), oe(() => {
    Q();
  }), {
    id: l,
    widget: i,
    subscriptionManager: T
  };
}
const Re = ["id"], qe = /* @__PURE__ */ se({
  name: "e-trading-view",
  __name: "trading-view",
  props: {
    interval: { default: "5" },
    libraryPath: { default: "charting_library/" },
    theme: {},
    customCSSUrl: {},
    exchangeName: {},
    instrumentName: {},
    displayName: {},
    volumePrecision: {},
    pricescale: {},
    supportedResolutions: { default: () => _e },
    count: { default: 300 },
    getBars: {},
    quote: {},
    debug: { type: Boolean },
    datafeedLogEnabled: { type: Boolean },
    widgetOptions: { default: () => V },
    disabledFeatures: { default: () => [] },
    enabledFeatures: { default: () => [] }
  },
  emits: ["interval-change", "instrument-change", "chart-ready"],
  setup(o, { emit: t }) {
    const e = o, r = t, { instrumentName: s, displayName: n, pricescale: p, volumePrecision: u, disabledFeatures: a, enabledFeatures: c } = ne(e), {
      count: g,
      supportedResolutions: w,
      getBars: l,
      datafeedLogEnabled: y,
      libraryPath: S,
      customCSSUrl: d,
      debug: C,
      theme: T,
      exchangeName: h
    } = e, L = m(() => le({}, V, e.widgetOptions)), b = m(() => L.value.marks || []), I = {
      count: g,
      supportedResolutions: w,
      instrumentName: s,
      displayName: n,
      pricescale: p,
      volumePrecision: u,
      getBars: l,
      marks: b,
      logEnabled: y,
      exchangeName: h
    }, F = m(() => Se(e.interval)), { id: A, subscriptionManager: D } = xe({
      interval: F,
      instrumentName: s,
      datafeedOptions: I,
      libraryPath: S,
      customCSSUrl: d,
      debug: C,
      theme: T,
      widgetOptions: L,
      emit: r,
      disabledFeatures: a,
      enabledFeatures: c
    }), x = m(() => `${s.value}_#_${F.value}`);
    return _(x, (P, k) => {
      try {
        const B = D.getSubscription(k);
        B && B.onResetCacheNeededCallback();
      } catch (B) {
        console.log(B);
      }
    }), _(() => e.quote, (P) => {
      if (P?.instrumentName === s.value && P.interval === e.interval && D) {
        const k = D.getOnTick(x.value);
        k && k(P.data[0]);
      }
    }), (P, k) => (ie(), ae("div", {
      id: W(A),
      class: "e-trading-view"
    }, null, 8, Re));
  }
});
export {
  qe as default
};
//# sourceMappingURL=trading-view.js.map
